<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/IN9/IN9.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">IN 9.0座舱域控制器</div>
                <div class="detail-banner-desc">
                    IN9.0基于第三代平台SA8155P；<br />
                    支持多屏交互、3D动画效果、高品质音效等信息娱乐功能；<br />
                    硬件配置十分灵活，能够匹配不同的车型功能。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            高通第三代骁龙数字座舱平台<br />
                        </div>
                        <div>
                            单颗芯片支持多操作系统（QNX/Android）<br />
                        </div>
                        <div>
                            最高支持5个显示屏、9路摄像头、2个模拟麦克风、6路麦克风<br />
                        </div>
                        <div>
                            3路百兆/1路千兆以太网, 4路CAN （FD），2路LIN
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN9/IN9-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">7nm</div>
                                    <div class="k">制程</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">105K DMIPS</div>
                                    <div class="k">CPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1100 GFLOPS</div>
                                    <div class="k">GPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">8 TOPS</div>
                                    <div class="k">NPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Up to 5</div>
                                    <div class="k">显示屏</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">12/16G + 128/256G</div>
                                    <div class="k">存储</div>
                                </div>
                                
                                <div class="spec-item spec-item-last">
                                    <div class="v">BT5.0 & BLE、WIFI5</div>
                                    <div class="k">蓝牙WIFI</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">1000 Base-T1 + 3*100 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>   
                                
                                                          
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                
                                <div class="spec-item spec-item-last">
                                    <div class="v">BT5.0 & BLE、WIFI5</div>
                                    <div class="k">蓝牙WIFI</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">1000 Base-T1 + 3*100 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>                            
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN9/IN9-1.jpg" alt="200-1-02">
                    </div>
                </div> -->

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'IN 9.0座舱域控制器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/IN9.html'
};

import { createApp } from 'vue';
import App from './IN9.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./IN9.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
